// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZVUVw","actions":"styles_actions__3xEnQ","error":"styles_error__3jS5L","message":"styles_message__24yoV"};